import store from "../store/index.js";

// router/routeGuards.js
export function globalBeforeEachGuard(router) {
  router.beforeEach((to, from, next) => {
    const operatorRole = store.state.operatorRole;
    // console.log("Guard: operatorRole =", operatorRole);

    // Se la rotta richiede ruolo ceo
    if (to.meta.requiresCeo) {
      if (operatorRole !== "ceo") {
        // Se l'utente non è ceo e NON sta già andando a /operator-quotes,
        // reindirizza a /operator-quotes
        if (to.path !== "/operator-quotes") {
          return next("/operator-quotes");
        }
        // Se sta già andando a /operator-quotes, non fare nulla
        // (altrimenti generi loop)
        return next();
      }
    }

    // Altrimenti prosegui
    return next();
  });
}
